export default __webpack_public_path__ + "static/media/calendarIcon-filled.a9e6e537.svg";